import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ConfirmDialogService } from '../../../core/confirm-dialog/confirm-dialog-service';
import { FormMode, MerchantAccountStatus } from '../../../core/constants';
import { Merchant } from '../../../models/merchant/merchant';
import { MerchantService } from '../../../models/merchant/merchantService';
import { UIErrorHandler } from '../../../core/uiErrorHandler';
import { UIHelpers } from '../../../core/ui-helpers';
import { CacheService } from '../../../core/storage/cacheService';
import { BaseComponent } from '../../baseComponent';
import { ListItem } from '../../../../../../../libs/Shared/components/model/listItem';

@Component({
  selector: 'app-merchant-api',
  templateUrl: './merchant-api.component.html',
  standalone: false,
})
export class MerchantApiComponent extends BaseComponent {
  @Input() merchant: Partial<Merchant> = Merchant.createEmpty();
  @Input() enableEditing: boolean = false;
  @Input() mode: FormMode = FormMode.View;
  @Output() saved = new EventEmitter<boolean>();

  data: Partial<Merchant> = Merchant.createEmpty();
  accountStatusOptions: ListItem[] = CacheService.accountStatusList;
  selectedAccountStatus: MerchantAccountStatus | undefined;

  timezoneOptions = CacheService.timeZoneList;

  constructor(
    private merchantService: MerchantService,
    private confirmDialog: ConfirmDialogService,
    private uiErrorHandler: UIErrorHandler,
  ) {
    super();
  }

  ngOnInit() {
    this.copyModelData(this.merchant, this.data);

    if (this.merchant.accountStatus) {
      this.selectedAccountStatus = this.merchant.accountStatus;
    }
  }

  private copyModelData(
    source: Partial<Merchant>,
    destination: Partial<Merchant>,
  ) {
    destination.id = source.id;
    destination.apiEnabled = source.apiEnabled;
    destination.apiKey = source.apiKey;
    destination.apiPassphrase = source.apiPassphrase;
  }

  btnEdit_click() {
    this.copyModelData(this.merchant, this.data);

    this.mode = FormMode.Edit;
  }

  btnCancel_click() {
    this.copyModelData(this.merchant, this.data);

    this.mode = FormMode.View;
    this.saved.emit(false);
    UIHelpers.scrollToTopIfOffPage('apiInformationContainer');
  }

  async btnSave_click() {
    var that = this;

    this.merchantService
      .patchMerchantAPIInfo(this.data)
      .then((savedMerchant) => {
        this.copyModelData(this.data, this.merchant);

        that.mode = FormMode.View;
        this.saved.emit(true);
        UIHelpers.scrollToTopIfOffPage('apiInformationContainer');
      })
      .catch((message) => {
        this.uiErrorHandler.handleError(message);
      });
  }

  btnChangeAccountStatus_click() {
    if (
      this.merchant.id &&
      this.selectedAccountStatus &&
      this.selectedAccountStatus != this.merchant.accountStatus
    ) {
      //TODO: create a new confirm-dialog component, just like core/error-dialog

      this.confirmDialog
        .confirm(
          'Change account status',
          "Are you sure you want to change this merchant's status to " +
            this.selectedAccountStatus +
            '?',
        )
        .subscribe((yesDoIt) => {
          if (
            yesDoIt &&
            this.merchant.id &&
            this.selectedAccountStatus != null
          ) {
            this.merchantService
              .patchMerchantAccountStatus(
                this.merchant.id,
                this.selectedAccountStatus,
              )
              .then((response) => {
                this.merchant.accountStatus = this.selectedAccountStatus;
                this.saved.emit(true);
              })
              .catch((message) => {
                this.uiErrorHandler.handleError(message);
              });
          }
        });
    }
  }
}
